export default "__VITE_ASSET__EM4f0yKv__"